const LOWER = "abcdefghijkmnopqrstuvwxyz";
const UPPER = "ABCDEFGHJKLMNPQRSTUVWXYZ";
const DIGITS = "23456789";
const SPECIAL = "!@#$%^&*";
const ALL = LOWER + UPPER + DIGITS + SPECIAL;

function pick(chars) {
    return chars[Math.floor(Math.random() * chars.length)];
}

/** Matches backend CreateCreatorRequest: digit, [!@#$%^&*], lower, upper, length >= 7. */
export function generateCreatorPassword(length = 12) {
    const required = [pick(LOWER), pick(UPPER), pick(DIGITS), pick(SPECIAL)];
    const rest = Array.from({ length: Math.max(0, length - required.length) }, () => pick(ALL));
    const chars = [...required, ...rest];
    for (let i = chars.length - 1; i > 0; i -= 1) {
        const j = Math.floor(Math.random() * (i + 1));
        [chars[i], chars[j]] = [chars[j], chars[i]];
    }
    return chars.join("");
}

export const FAN_APP_URL = "https://app.tlknow.ai";
export const CREATOR_URL = "https://creators.tlknow.ai/";
export const CREATOR_PASSWORD_PATTERN = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{7,}$/;

export function fanAppMagicLink(username) {
    const handle = (username || "").trim();
    if (!handle) return "";
    return `${FAN_APP_URL}/${handle}`;
}

export function creatorDisplayName(row) {
    const name = [row?.first_name, row?.last_name].filter(Boolean).join(" ").trim();
    return name || row?.username || "Creator";
}

export function credentialRows(credentials) {
    if (!credentials) return [];
    return [
        { key: "username", label: "Username", value: credentials.username || "" },
        { key: "email", label: "Email", value: credentials.email || "" },
        { key: "password", label: "Password", value: process.env.REACT_APP_CREATOR_DEFAULT_PASSWORD || "" },
        {
            key: "fanAppUrl",
            label: "Fan app magic link",
            value: credentials.fanAppUrl || fanAppMagicLink(credentials.username),
        },
        { key: "creatorUrl", label: "Creator URL", value: CREATOR_URL },
    ];
}

export function formatCreatorCredentials(credentials) {
    return credentialRows(credentials)
        .map((row) => `${row.label}: ${row.value || "—"}`)
        .join("\n");
}

export function credentialsFromCreator(row) {
    if (!row) return null;
    return {
        displayName: creatorDisplayName(row),
        username: row.username || "",
        email: row.email || "",
        password: process.env.REACT_APP_CREATOR_DEFAULT_PASSWORD || "",
        fanAppUrl: fanAppMagicLink(row.username),
    };
}

const PASSWORD_STORE_KEY = "syntimacy.creatorPasswords";

export function rememberCreatorPassword(userId, password) {
    if (!userId || !password || typeof sessionStorage === "undefined") return;
    try {
        const map = JSON.parse(sessionStorage.getItem(PASSWORD_STORE_KEY) || "{}");
        map[userId] = password;
        sessionStorage.setItem(PASSWORD_STORE_KEY, JSON.stringify(map));
    } catch (err) {
        console.error("Could not store creator password for this session:", err);
    }
}

export function recalledCreatorPassword(userId) {
    if (!userId || typeof sessionStorage === "undefined") return "";
    try {
        const map = JSON.parse(sessionStorage.getItem(PASSWORD_STORE_KEY) || "{}");
        return map[userId] || "";
    } catch {
        return "";
    }
}
